import { jsx as a } from "react/jsx-runtime";
import s from "./help-center-knowledge-anatomies11.js";
import { useMemo as c } from "react";
import { initReactI18next as l } from "./help-center-knowledge-anatomies12.js";
import { I18nextProvider as m } from "./help-center-knowledge-anatomies13.js";
function x(o) {
  const { locale: e, localizationData: t, children: r } = o, i = c(() => {
    const n = s.createInstance().use(l);
    return n.init({
      resources: t,
      fallbackLng: "en_us",
      lng: e?.toLowerCase()?.replace("-", "_") || "en_us",
      ns: ["vistaprint"],
      defaultNS: "vistaprint",
      debug: !1,
      interpolation: {
        escapeValue: !1
      }
    }), n;
  }, [e, t]);
  return /* @__PURE__ */ a(m, { i18n: i, children: r });
}
export {
  x as LocalizationProvider
};
//# sourceMappingURL=help-center-knowledge-anatomies4.js.map
